<template>
  <news-list title="pig"></news-list>
</template>

<script>
import newsList from './components/list'

export default {
  name: 'pigNews',
  components: { newsList },
  data () {
    return {}
  }
}
</script>
